import { execute } from '../../helpers/apiInstance';

export const getEquipmentData = () => {
  return execute('GET', `/ui/apis/get-equipment-mfrs`);
};

export const getEquipmentModals = (dataObj) => {
  return execute(
    'POST',
    `/ui/apis/get-equipment-modals?${new URLSearchParams(dataObj).toString()}`,
    {},
    'json'
  );
};

export const updateEquipmentApi = (dataObj) => {
  const formData = new FormData();
  formData.append('formFile', dataObj?.formFile);
  const params = { EquipmentType: dataObj?.EquipmentType };
  return execute(
    'POST',
    `/ui/apis/update-equipment?${new URLSearchParams(params).toString()}`,
    formData,
    'json',
    'multipart/form-data'
  );
};
